export const BASE_THEME_ID = 'base';
export const BASE_OFFICE_THEME_ID = 'basewithofficethemepreferred';
export const CONTRAST_THEME_ID = 'contrast';
